import { Directive } from '@angular/core';
import { AbstractControl, Validator, NG_VALIDATORS } from '@angular/forms';

@Directive({
  selector: '[appAmountNumberValidator]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: AmountValidatorDirective,
    multi: true
  }] 
})
export class AmountValidatorDirective implements Validator {
  validate(control: AbstractControl) : {[key: string]: any} | null {
    if (control.value < 1 || control.value > 999999999) {
      return { 'amountInvalid': true };
    }
    return null;
  }
}


// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/amount-validator.directive.ts